import * as v from "valibot";

import { rpcContract } from "../rpc";

export const subscribeConfirmationRpcContract = rpcContract({
  name: "subscribeConfirmation" as const,
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
    subscriptionHandle: v.pipe(
      v.string(),
      v.minLength(3, "Subscription handle must be at least 3 characters"),
      v.regex(
        /^[a-z0-9_\-.]+$/,
        "Subscription handle can only contain lowercase letters, numbers, underscores, hyphens, and dots",
      ),
    ),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.string(),
  }),
});

export type SubscribeConfirmationParams = v.InferOutput<(typeof subscribeConfirmationRpcContract)["paramsSchema"]>;
export type SubscribeConfirmationResult = v.InferOutput<(typeof subscribeConfirmationRpcContract)["resultSchema"]>;
